import React from 'react'
import _ from 'lodash'
import { Button } from 'antd'
import { useI18n, usePersonalInfo } from 'contexts/AuthContext'
import { ScheduleDateTimeSelector } from 'components/ScheduleDatePicker/index'
import classes from './index.module.scss'

const ScheduleContent = (props) => {
  const {
    selectedAppointmentType,
    providerId,
    selectedProviderIds,
    providerIds,
    selectedSlot,
    setSelectedSlot,
    isLoading,
    setPayLoading,
    setBookPayLoading,
    completeBookingAppointment,
    setBookedAppointment,
    payLoading,
    bookLoading,
    onCardPay,
    hideTimeZone,
    showSkip,
    onSkip,
    selectedLanguage,
    onLanguageChange,
    setScheduleLanguage,
    logScheduleClickEvent,
  } = props
  const { personalInfo } = usePersonalInfo()
  const { i18n } = useI18n()

  return (
    <div className={classes.styles}>
      {!isLoading ? (
        <>
          <ScheduleDateTimeSelector
            selectedAppointmentType={selectedAppointmentType}
            providerId={!_.isEmpty(selectedProviderIds) ? providerId : ''}
            providerIds={providerIds}
            state={personalInfo.state?.code || ''}
            selectedSlot={selectedSlot}
            setSelectedSlot={setSelectedSlot}
            moveToNextStep={() => {}}
            hideTimeZone={hideTimeZone}
            selectedLanguage={selectedLanguage}
            setSelectedLanguage={onLanguageChange}
            setScheduleLanguage={setScheduleLanguage}
          />
          <Button
            className='btn-primary full-width-btn book-btn'
            onClick={() => {
              logScheduleClickEvent({
                choice: 'schedule',
              })
              if (props.paymentMethod && props.product) {
                setPayLoading(true)
                onCardPay(props.paymentMethod)
              } else {
                setBookPayLoading(true)
                completeBookingAppointment({
                  slot: selectedSlot,
                  selectedAppointmentType,
                  onSuccess: (appointment) => {
                    setBookedAppointment(appointment)
                    setBookPayLoading(false)
                    setSelectedSlot(null)
                  },
                  onFailure: () => {
                    setBookPayLoading(false)
                  },
                })
              }
            }}
            disabled={!selectedSlot || payLoading || bookLoading}
          >
            {i18n('Next')}
          </Button>
          {showSkip && (
            <Button
              className='full-width-btn m-t-2 btn-normal text-underline'
              onClick={() => {
                logScheduleClickEvent({
                  choice: 'skip',
                })
                onSkip?.()
              }}
              disabled={payLoading || bookLoading}
            >
              {i18n('Skip')}
            </Button>
          )}
        </>
      ) : (
        <div></div>
      )}
    </div>
  )
}

export default ScheduleContent
